import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('reports');

const reportsRoutes = [
  {
    path: '/reports',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        meta: { showNav: true, feature: 'reports' },
        props: true,
        component: loadView('Reports'),
      },
      {
        path: 'activity',
        name: 'reportsActivity',
        props: true,
        meta: {
          feature: 'reports',
        },
        component: loadView('components/ReportActivityFeed'),
      },
      {
        path: ':id',
        component: {
          render: (c) => c('router-view'),
        },
        children: [
          {
            path: '',
            name: 'report',
            props: true,
            meta: {
              feature: 'reports',
            },
            component: loadView('Report'),
          },
          {
            path: 'records',
            name: 'customReports',
            props: true,
            meta: {
              feature: 'reports',
            },
            component: loadView('CustomReports'),
          },
          {
            path: 'records/:customReportId',
            name: 'customReport',
            props: true,
            meta: {
              feature: 'reports',
            },
            component: loadView('CustomReport'),
          },
        ],
      },
    ],
  },
];

export default reportsRoutes;
